import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import B2CServiceHistoryOverviewCard from './B2CServiceHistoryOverviewCard';

const B2CServiceHistoryOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:verification.service_history_request.overview.meta.title')} />
      <B2CServiceHistoryOverviewCard />
    </ContentLayout>
  );
};

export default B2CServiceHistoryOverviewPage;
